import MediaV2 from "./media_v2"

export type { MediaV2Props } from "./interface"
export default MediaV2
